<template>
    <reset-password-form form-name="reset_password_form" :fixed-data="fixedData" />
</template>
<script>
import ResetPasswordForm from './form/ResetPasswordForm';
export default {
    name: 'forget-password-page',
    components: {
        ResetPasswordForm
    },
    data: function() {
        return {
            fixedData: null
        };
    },
    created() {
        this.fixedData = this.$route.query;
    }
};
</script>

